import React, { ReactNode } from 'react';

import useStyles from './styles';

interface Props {
    title: string;
    children: ReactNode;
    className?: string;
}

const Question: React.FC<Props> = ({ title, children, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <p className={classes.title}>{title}</p>
            <p className={classes.content}>{children}</p>
        </div>
    );
};

export default Question;
